<div class="snackbar-container" *ngIf="snackbar">
  <div class="snackbar">
    <i [ngClass]="['icon fa-light', snackbar.level, iconLevel()]"></i>
    <div class="snackbar-value">
      <span class="snackbar-label">{{ snackbar.title | translate:snackbar?.messageVariables }}</span>
      <span *ngIf="snackbar.description"
        class="snackbar-description">{{ snackbar.description | translate:snackbar?.messageVariables }}</span>
      <a *ngIf="snackbar.link" [href]="snackbar.link.url">{{ snackbar.link.label }}</a>
    </div>
    <i class="close-snackbar fa-sharp fa-light fa-xmark" (click)="closeSnackbar()"></i>
  </div>
</div>
